import { z } from 'zod'
import { oc } from '@orpc/contract'
import { taskRunSchema } from './tasks-shared.contract'

/** One run, including the full log. `slug` must match the run's task, else 404. */
export const getTaskRun = oc
  .route({ method: 'GET', path: '/v2/tasks/{slug}/runs/{id}' })
  .input(z.object({ slug: z.string().min(1), id: z.coerce.number().int().positive() }))
  .output(z.object({ data: taskRunSchema }))
